import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
// import AddPayment from "../../../core/data/modals/addpayment";
// import AddCard from "../../../core/data/modals/addcard";
import Aos from "aos";
import { Table } from "antd";
import { all_routes } from "../router/all_routes";
import { useSelector } from "react-redux";
import { userWalletData } from "../../types/userWalletData";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { observer } from "mobx-react-lite";
import Header from "../common/header";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Button, Card } from "react-bootstrap";
import { FiLogOut } from "react-icons/fi";
import { PartnerpaymentType } from "../../lib/utils";
import toast from "react-hot-toast";
import { useStore } from "../../app/stores/store";


const PartnerWallet = observer(() => {

  const navigate = useNavigate();

  const [depositAmount, setDepositAmount] = useState('');
  const [paymentType, setPaymentType] = useState(''); // 'direct', 'bank', or 'online'
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [pendingPayments, setPendingPayments] = useState([]);
  const [locationPathname, setLocationPathname] = useState(location.pathname);
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  const [receiptFile, setReceiptFile] = useState<File | null>(null);
  const { userStore, paymentStore } = useStore();
  const user = userStore.user;
  const securityAmount = user?.securityDepositAmount ?? 0;
  const isValidAmount =
    depositAmount &&
    (paymentType === "online" ? parseFloat(depositAmount) >= 10000 : parseFloat(depositAmount) > 0);

  const onlineCharge = paymentType === "online" && isValidAmount
    ? (parseFloat(depositAmount) * 0.03).toFixed(2)
    : "0.00";

  const totalAmount = paymentType === "online" && isValidAmount
    ? (parseFloat(depositAmount) * 1.03).toFixed(2)
    : depositAmount && parseFloat(depositAmount) >= 10000
      ? parseFloat(depositAmount).toFixed(2)
      : "0.00";

  const onConfirmClick = () => {
    setError('');
    handleConfirmSecurityDeposit();
  };

  const handleConfirmSecurityDeposit = async () => {
    const user = userStore.user;

    if (!user || !user.id) {
      setError("User information is missing. Please log in again.");
      return;
    }

    const type: PartnerpaymentType = { type: paymentType };

    if (!paymentType) {
      setError("You must choose a payment method.");
      return;
    }

    // Only validate deposit amount if payment is "online"
    if (paymentType === "online") {
      if (!depositAmount || parseFloat(depositAmount) <= 0) {
        setError("Please enter a valid deposit amount.");
        return;
      }

      if (parseFloat(depositAmount) < 10000) {
        setError("Minimum deposit amount for online payment is AED 10,000.");
        return;
      }
    }


    if (paymentType === "direct" || paymentType === "bank") {
      try {
        await userStore.setPaymentTypeOfPartner(user.id, type);
        toast.success(`Deposit payment method set to ${paymentType}`);
      } catch (err) {
        toast.error("Error updating payment method.");
      }
    } else if (paymentType === "online") {
      setIsLoading(true);
      const formData = new FormData();

      formData.append("Type", "partner");

      formData.append("TransactionAmount", parseFloat(totalAmount).toFixed(2));

      formData.append("IDS", user.id);
      formData.append("OrderName", "SecurityDeposit");


      try {
        const result = await paymentStore.initiatePayment(formData);
        if (result?.status === "success") {
          await userStore.setPaymentTypeOfPartner(user.id, type);
          window.location.href = result.data as string;
        } else {
          toast.error("Payment initiation failed!");
          toast.error(`Payment initiation failed: ${result?.error || "Unknown error"}`);

        }
      } catch (err) {
        toast.error("Error initiating payment.");
      } finally {
        setIsLoading(false);
      }
    }
  };


  const handleLogout = () => {
    userStore.logout();
    navigate("/login");
  };


  const routes = all_routes
  const data = useSelector((state: userWalletData) => state.userwallet_data);
  const columns = [
    {
      title: "Ref Id",
      dataIndex: "refid",
    },
    {
      title: "Transaction For",
      dataIndex: "transactionfor",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Total",
      dataIndex: "total",
      render: (text: any) => {
        const isPositive = text.startsWith("+");

        return (
          <span className={isPositive ? "text-success-light" : "text-danger"}>
            {text}
          </span>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: any) => (
        <div>
          {text === "Completed" && (
            <span className="badge badge-light-success">{text}</span>
          )}
          {text === "Pending" && (
            <span className="badge badge-light-warning">{text}</span>
          )}
          {text === "Failed" && (
            <span className="badge badge-light-danger">{text}</span>
          )}
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: () => (
        <div className="text-end">
          <div className="dropdown dropdown-action">
            <Link
              to="#"
              className="dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i
                data-feather="fas fa-ellipsis-vertical"
                className="fas fa-ellipsis-vertical"
              ></i>
            </Link>
            <div className="dropdown-menu dropdown-menu-end">
              <Link className="dropdown-item" to="#">
                <i className="feather icon-edit-3"></i> Edit
              </Link>
              <Link
                className="dropdown-item"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#delete_modal"
              >
                <i className="feather icon-trash-2"></i> Delete
              </Link>
            </div>
          </div>
        </div>
      ),
    },

    // <td class="text-end">
    //   <div class="dropdown dropdown-action">
    //     <Link
    //       to="#"
    //       class="dropdown-toggle"
    //       data-bs-toggle="dropdown"
    //       aria-expanded="false"
    //     >
    //       <i class="fas fa-ellipsis-vertical"></i>
    //     </Link>
    //     <div class="dropdown-menu dropdown-menu-end">
    //       <Link class="dropdown-item" to="#">
    //         <i class="feather icon-edit-3"></i> Edit
    //       </Link>
    //       <Link
    //         class="dropdown-item"
    //         to="#"
    //         data-bs-toggle="modal"
    //         data-bs-target="#delete_modal"
    //       >
    //         <i class="feather icon-trash-2"></i> Delete
    //       </Link>
    //     </div>
    //   </div>
    // </td>,
  ];
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys: React.SetStateAction<never[]>) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);


  return (
    <>
      <Sidebar />


      <div className="relative md:ml-64 bg-blueGray-100">
        {/* Header */}
        <div className="relative bg-[#b60072] md:pt-2 pb-3 pt-12">
          <div className="px-4 md:px-10 mx-auto w-full">
            {userStore.isLoggedIn && (
              <div className="d-flex justify-content-between align-items-center px-4 py-3">
                <span style={{ color: "#fff" }}>
                  Welcome, {userStore.user?.displayName || 'Partner'}
                </span>
                <Button
                  variant="light"
                  size="sm"
                  onClick={handleLogout}
                  className="d-flex align-items-center gap-2"
                  style={{ color: "#b60072", fontWeight: "bold" }}
                >
                  <FiLogOut size={16} /> Logout
                </Button>
              </div>
            )}
          </div>
        </div>

        <div>
          <div className="flex flex-wrap">

            <div className="col-lg-5 col-md-12 d-flex">
              <div className="card wallet-card flex-fill">
                <div className="card-body">
                  <div className="balance-info">
                    <div className="balance-grid">
                      <div className="balance-content">
                        <h6>Available Balance</h6>


                        <h4>
                          AED{" "}

                          {user?.securityDepositAmount || '0.00'}
                        </h4>
                      </div>
                      <div className="refersh-icon">
                        <i className="fas fa-arrows-rotate" />

                      </div>
                    </div>
                    <div className="balance-list">
                      <div className="row">
                        <div className="col-lg-4 col-md-6 d-flex">
                          <div className="balance-inner credit-info">
                            <h6>AED {user?.securityDepositAmount || '0.00'}</h6>
                            <p>Total Credit</p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 d-flex">
                          <div className="balance-inner debit-info">
                            <h6>AED 7,357</h6>
                            <p>Total Debit</p>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6 d-flex">
                          <div className="balance-inner transaction-info">
                            <h6>AED 6,56,415</h6>
                            <p>Total Transaction</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>

          </div>
          {/* /Wallet Info */}
          {/* Wallet Table */}
          <div className="row">
            <div className="col-lg-12 d-flex">
              <div className="card book-card flex-fill mb-0">
                <div className="card-header">
                  <div className="row align-items-center">
                    <div className="col-lg-12 mb-4">
                      <h4>Wallet Usage History</h4>
                      <Card.Body className="p-4">

                        {error && <div className="alert alert-danger">{error}</div>}

                        <div className="mb-4">
                          <label className="form-label fw-semibold">Deposit Amount (AED)</label>

                          {paymentType === "direct" && (
                            <div className="alert alert-info mt-2 p-3">
                              💼 Please proceed to the center to pay the security deposit.
                            </div>
                          )}

                          {paymentType === "bank" && (
                            <>
                              <div className="alert alert-info mt-2 p-3">
                                💼 Once the security deposit of minimum AED 10,000 is transferred to the below mentioned account, please attach the receipt here.
                              </div>

                              {/* Receipt upload */}
                              <label className="form-label fw-semibold">Upload Receipt</label>
                              <input
                                type="file"
                                accept="image/*,application/pdf"
                                className="form-control"
                                onChange={(e) => setReceiptFile(e.target.files?.[0] || null)}
                                style={{ maxWidth: "220px" }}
                              />
                            </>
                          )}

                          {paymentType === "online" && (
                            <>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                className="form-control shadow-sm"
                                placeholder="Enter deposit amount"
                                value={depositAmount}
                                onChange={(e) => setDepositAmount(e.target.value)}
                                style={{ maxWidth: "220px" }}
                              />
                              {depositAmount && (
                                <div className="alert alert-info mt-3 p-3">
                                  <p className="mb-1"><strong>🧾 3% Online Payment Fee:</strong> AED {onlineCharge}</p>
                                  <p className="mb-0"><strong>💰 Total Payable:</strong> AED {totalAmount}</p>
                                </div>
                              )}
                            </>
                          )}
                        </div>




                        <div className="mb-4">
                          <label className="form-label fw-semibold mb-2">Choose Payment Method</label>
                          <div className="d-flex flex-wrap gap-3">
                            {/* Direct Payment */}
                            <label className="d-flex align-items-center border border-secondary-subtle rounded shadow-sm p-2 px-3 cursor-pointer">
                              <i className="fas fa-money-bill-wave text-success me-2"></i>
                              <input
                                type="radio"
                                value="direct"
                                checked={paymentType === "direct"}
                                onChange={(e) => setPaymentType(e.target.value)}
                                className="me-2"
                              />
                              Cash Payment
                            </label>

                            {/* Online Payment */}
                            <label className="d-flex align-items-center border border-secondary-subtle rounded shadow-sm p-2 px-3 cursor-pointer">
                              <img src="/assets/img/etisalatLogo.gif" className="me-2" style={{ width: 24, height: 24 }} alt="Online" />
                              <input
                                type="radio"
                                value="online"
                                checked={paymentType === "online"}
                                onChange={(e) => setPaymentType(e.target.value)}
                                className="me-2"
                              />
                              Online Payment
                            </label>

                            {/* Bank Transfer */}
                            <label className="d-flex align-items-center border border-secondary-subtle rounded shadow-sm p-2 px-3 cursor-pointer">
                              <img src="/assets/img/etisalatLogo.gif" className="me-2" style={{ width: 24, height: 24 }} alt="Bank" />
                              <input
                                type="radio"
                                value="bank"
                                checked={paymentType === "bank"}
                                onChange={(e) => setPaymentType(e.target.value)}
                                className="me-2"
                              />
                              Bank Transfer
                            </label>
                          </div>
                        </div>

                        {/* Bank Details Section */}
                        {paymentType === "bank" && (
                          <div className="alert alert-light border border-secondary-subtle">
                            <h6 className="fw-bold mb-2">🏦 Bank Transfer Details</h6>
                            <p className="mb-1"><strong>Bank:</strong> Wio Bank</p>
                            <p className="mb-1"><strong>Account:</strong> UBER TRAVEL AGENCY L.L.C</p>
                            <p className="mb-1"><strong>Number:</strong> 09189995985</p>
                            <p className="mb-1"><strong>IBAN:</strong> AE920860000009189995985</p>
                            <p className="mb-0"><strong>SWIFT:</strong> WIOBAEDXXX</p>
                          </div>
                        )}

                        <Button
                          variant="primary"
                          disabled={isLoading}
                          onClick={onConfirmClick}
                          className="mt-3"
                        >
                          {isLoading ? "Processing..." : "✅ Confirm Deposit"}
                        </Button>
                      </Card.Body>

                    </div>

                    <div className="col-md-7 text-md-end">
                      {/* <div className="search-input">
                        <input
                          type="text"
                          placeholder="Search"
                          className="form-control form-control-sm formsearch"
                        />
                        <Link to="#" className="btn btn-searchset">
                          <i data-feather="search" className="feather icon-search" />
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive dashboard-table">

                    <Table />
                  </div>
                  <div className="table-footer">
                    <div className="row">
                      <div className="col-md-6">
                        <div id="tablelength" />
                      </div>
                      <div className="col-md-6 text-md-end">
                        <div id="tablepage" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Wallet Table */}
        </div>
      </div>
      {/* /Page Content */}
      {/* <LinkddPayment />
      <LinkddCard /> */}



    </>
  );
});
export default PartnerWallet;